<template>
    <div>
     
      <HeroSection />

      <div class="wrapper">
        <RecentPhotos />
      </div>
      
  
    </div>
</template>

<script>

import HeroSection from '../components/HeroSection'
import RecentPhotos from '../views/RecentPhotos'


export default {

  components:{

    HeroSection,
    RecentPhotos
    
  }
  
}
</script>